export default __webpack_public_path__ + "static/media/legal-hammer.f11ca209.jpg";